import { render, staticRenderFns } from "./ContestPanelView.vue?vue&type=template&id=53d3096c&"
import script from "./ContestPanelView.vue?vue&type=script&lang=js&"
export * from "./ContestPanelView.vue?vue&type=script&lang=js&"
import style0 from "./ContestPanelView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
